import { IdentityState, User } from "contexts/identity-context";

const resolveIdentityId = (identityState: IdentityState): string => {
  const user = identityState as User;
  return user?.activeOrg?.organisationId ?? user?.organisations?.find((x) => x.active)?.organisationId ?? "";
};

export { resolveIdentityId };
